import { ApiError, isGuest, type Lang, request, withPicture } from '@/api/client';
import type { Question } from '@/api/questions';
import { BANK, checked } from '@/api/shape';

export interface Bank {
  data: string[];
  count: number;
  position: number;
  questions: Question[];
}

export function getBank(lang: Lang): Promise<Bank> {
  if (isGuest()) return Promise.reject(new ApiError(401, 'guest'));
  return request<unknown>(`/me/bank?lang=${lang}`)
    .then(checked<Bank>(BANK, 'bank'))
    .then((bank) => ({ ...bank, questions: bank.questions.map(withPicture) }));
}

export function saveBankPosition(position: number): Promise<void> {
  if (isGuest()) return Promise.reject(new ApiError(401, 'guest'));
  return request<unknown>('/me/bank/position', {
    method: 'PATCH',
    body: JSON.stringify({ position }),
  }).then(() => undefined);
}
